import React__default from 'react';
import { LegacyIconButton } from '../LegacyIconButton/IconButton.es.js';
import { clamp } from '../../../utils/clamp.es.js';
import { NumberButton } from './NumberButton/NumberButton.es.js';

const root = "_root_1jvc0_1";
const text = "_text_1jvc0_15";
const styles = {
	root: root,
	text: text
};

const PaginatorText = (props) => {
  const maxChars = `${props.numberOfPages}`.length * 2 + 4;
  return React__default.createElement("span", { className: styles.text, "data-zds": true, style: {
    "--paginator-min-width": `${maxChars}ch`
  } }, `${props.currentPageIndex + 1} of ${props.numberOfPages}`);
};
const Paginator = ({ currentPageIndex, pageUrls, "aria-label": ariaLabel = void 0, condenseAt = 6, firstPageUrl = void 0, isCentered = void 0, lastPageUrl = void 0, offset = 0, onPaginate = void 0 }) => {
  const numberOfPages = pageUrls.length;
  const maxPageIndex = numberOfPages - 1;
  const safeCurrentPageIndex = clamp(currentPageIndex, 0, maxPageIndex);
  const prevIndex = Math.max(0, safeCurrentPageIndex - 1);
  const nextIndex = Math.min(maxPageIndex, safeCurrentPageIndex + 1);
  const isCondensed = numberOfPages >= condenseAt;
  let numberOfButtons = numberOfPages;
  numberOfButtons += 2;
  if (firstPageUrl) {
    numberOfButtons++;
  }
  if (lastPageUrl) {
    numberOfButtons++;
  }
  const createOnPaginateFn = (buttonType, pageIndex, pageUrl) => {
    return (event) => {
      if (onPaginate) {
        onPaginate({
          buttonType,
          pageIndex,
          pageUrl
        }, event);
      }
    };
  };
  const content = isCondensed ? React__default.createElement(PaginatorText, { currentPageIndex: safeCurrentPageIndex, numberOfPages }) : pageUrls.map((pageUrl, pageIndex) => {
    const isSelected = pageIndex === safeCurrentPageIndex;
    const pageNumber = offset + pageIndex + 1;
    return React__default.createElement(NumberButton, { "aria-label": isSelected ? `Current page (${pageNumber})` : `${pageNumber}`, size: "medium", href: pageUrl, key: pageUrl || pageNumber, onClick: createOnPaginateFn("number", pageIndex, pageUrl), value: pageNumber, selected: isSelected });
  });
  const firstPageButtonUrl = firstPageUrl || (isCondensed ? pageUrls[0] : void 0);
  const firstPageButton = (firstPageButtonUrl || isCondensed) && React__default.createElement(LegacyIconButton, { "aria-label": "First page", color: "icon-tertiary", size: "medium", disabled: currentPageIndex <= 0, href: firstPageButtonUrl, icon: "arrowLineLeft", onClick: createOnPaginateFn("first", 0, firstPageButtonUrl), tooltipPosition: "southwest" });
  const lastPageButtonUrl = lastPageUrl || (isCondensed ? pageUrls[maxPageIndex] : void 0);
  const lastPageButton = (lastPageButtonUrl || isCondensed) && React__default.createElement(LegacyIconButton, { "aria-label": "Last page", color: "icon-tertiary", size: "medium", disabled: safeCurrentPageIndex >= maxPageIndex, href: lastPageButtonUrl, icon: "arrowLineRight", onClick: createOnPaginateFn("last", maxPageIndex, lastPageButtonUrl), tooltipPosition: "southeast" });
  return React__default.createElement(
    "nav",
    { "aria-label": ariaLabel ? ariaLabel : "Pagination navigation", className: styles.root, "data-zds": true, "data-condensed": isCondensed, "data-centered": isCentered, style: {
      "--_zds-paginator-button-count": numberOfButtons
    } },
    firstPageButton,
    React__default.createElement(LegacyIconButton, { "aria-label": `Previous page (${prevIndex + 1})`, color: "icon-tertiary", size: "medium", disabled: safeCurrentPageIndex <= 0, href: pageUrls[prevIndex], icon: "arrowSmallLeft", onClick: createOnPaginateFn("previous", prevIndex, pageUrls[prevIndex]), tooltipPosition: "southwest" }),
    content,
    React__default.createElement(LegacyIconButton, { "aria-label": `Next page (${nextIndex + 1})`, color: "icon-tertiary", size: "medium", disabled: safeCurrentPageIndex >= maxPageIndex, href: pageUrls[nextIndex], icon: "arrowSmallRight", onClick: createOnPaginateFn("next", nextIndex, pageUrls[nextIndex]), tooltipPosition: "southeast" }),
    lastPageButton
  );
};

export { Paginator };
//# sourceMappingURL=Paginator.es.js.map
